<template>
  <div class="course-detail-edite-wrap">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);padding:30px 20px;">
        <div class="course-detail-img">
          <img :src="couseCoverUrl" alt="">
        </div>  
        <div class="course-detail-info">
          <div class="course-detail-name">{{courseName}}</div>
          <div class="course-detail-price">￥{{price?price:"-"}}</div>
          <div class="course-detail-desc">
            <!-- <span >{{chCount}}</span>
            <span class="space-span-right">人在学</span>| -->
            <span class="space-span-left">课程进度：{{endHourCnt}}/{{hourCnt}}</span>
            <!--<span>{{chapterCount?chapterCount:0}}</span>
            <span>个章节 </span>
            <span class="">{{chCount?chCount:0}}</span>
            <span class="space-span-right">个课时</span>
            <!-- <span class="space-span-left">更新中</span> -->
          </div>
        </div>
        <!-- <div class="course-detail-right">
          <a-button @click="editeCourse()" type="primary" style="margin-left:8px;">编辑</a-button>
        </div> -->
      </a-card>
      <a-card :bordered="false" style="margin-top:10px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <a-tabs defaultActiveKey="1" >
          <a-tab-pane tab="课时管理" key="1">
            <ClassHourManage :courseId = "courseId"></ClassHourManage>
          </a-tab-pane>
          <!-- <a-tab-pane tab="学员管理" key="2" forceRender>
            <CourseStudentsManage></CourseStudentsManage>
          </a-tab-pane> -->
          <a-tab-pane tab="课程评价" key="2">
            <CourseRatingManage></CourseRatingManage>
          </a-tab-pane>
          <a-tab-pane tab="数据统计" key="3">
            <CourseDataStatistics></CourseDataStatistics>
          </a-tab-pane>
          <!-- <a-tab-pane tab="学习资料" key="5">Content of Tab Pane 5</a-tab-pane> -->

        </a-tabs>
      </a-card>
      <!-- <a-card :bordered="false" style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        
      </a-card> -->

  </div>
  
</template>

<script>

  import ClassHourManage from '../../components/onlineVideo/OnlineVideoDetailEdite/ClassHourManage' 
  import CourseDataStatistics from '../../components/onlineVideo/OnlineVideoDetailEdite/CourseDataStatistics'
  import CourseRatingManage from '../../components/onlineVideo/OnlineVideoDetailEdite/CourseRatingManage'
  
  import {onlineInfo} from '@/api/api'
  export default {
    name: 'CourseDetailEdite',
    components: {ClassHourManage,CourseDataStatistics,CourseRatingManage},
    mixins: [],
    data() {
      return {
        courseName:"2",//课程名称
        price:"",//课程加个
        chapterCount:"",//章节数
        couseCoverUrl:"",//封面
        endHourCnt:'',
        hourCnt:'',
        chCount:""//课时数
      }
    },
    created() {
      this.courseId = this.$route.query.courseId;
      this.getCourseDetailInfo();
    },
    methods: {
      getCourseDetailInfo(){
        onlineInfo({id:this.courseId}).then((res)=>{
          if(res.code==0){
            
            this.courseName = res.result.courseName;
            this.price = res.result.realPrice;
            this.chapterCount = res.result.chapterCount;
            this.couseCoverUrl = res.result.courseCoverFile.obsObjectUrl;
            this.chCount = res.result.chCount;
            this.hourCnt = res.result.hourCnt;
            this.endHourCnt = res.result.endHourCnt;

          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
      }

      
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .course-detail-edite-wrap{

    .course-detail-img{
      float:left;
      width:132px;
      height:86px;
      img{
        width:100%;
      }
    }
    .course-detail-info{
      float:left;
      margin-left:14px;
      .course-detail-name{
        color:#333333;
        margin-bottom:5px;
      }
      .course-detail-price{
        color:#FA6400;
        font-size:14px;
      }
      .course-detail-desc{
        color:#999999;
        font-size:12px;
        margin-top:26px;
        .space-span-left{
          padding-left:5px;
        }
        .space-span-right{
          padding-right:5px;
        }
      }
    }
    .course-detail-right{
      float:right;
    }

    

    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    } 

  }
  

</style>